module.exports = __webpack_public_path__ + "static/img/pkd-icon.35744bd3.png";